module.exports = __webpack_public_path__ + "removed.png?6984da7f1d79c702ec62008a0d8694cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/removed.png
// module id = 72
// module chunks = 0